import React from 'react';
import s from './CollapsiblePanel.module.css';
import IconArrowDown from '../icons/IconArrowDown';
type Props = {
    title: string;
    isOpen: boolean;
    onToggle: () => void;
    children: React.ReactNode;
};

export const CollapsiblePanel: React.FC<Props> = ({ title, isOpen, onToggle, children }) => (
    <div className={s.item}>
        <button className={s.button} onClick={onToggle}>
            <span>{title}</span>
            <div
                className={s.arrow}
                style={{
                    transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.3s ease',
                }}
            >
                <IconArrowDown width={10} />
            </div>
        </button>
        <div className={`${s.panel} ${isOpen ? s.open : ''}`}>{children}</div>
    </div>
);
